import { render, staticRenderFns } from "./totalExcavated.vue?vue&type=template&id=9ce21726&scoped=true"
import script from "./totalExcavated.vue?vue&type=script&lang=js"
export * from "./totalExcavated.vue?vue&type=script&lang=js"
import style0 from "./totalExcavated.vue?vue&type=style&index=0&id=9ce21726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce21726",
  null
  
)

export default component.exports